import { useQuery } from '@tanstack/react-query';
import { licenseDeviceKeys } from '@platform/billing';
import { STALE_TIME } from '@/shared/constants/app/time.constant';
import { licenseDeviceApi } from './license-device.api';

/** 계정 등록 기기 + 교체 횟수. 판정은 서버가 하고 화면은 그대로 보여준다. */
export function useMyDevices() {
  return useQuery({
    queryKey: licenseDeviceKeys.mine,
    queryFn: licenseDeviceApi.listMine,
    staleTime: STALE_TIME.SHORT,
  });
}
